export { staticQueries } from "#static-queries";
export type {
  StaticFindFirstQuery,
  StaticFindFirstQueryKey,
  StaticFindManyQuery,
  StaticFindManyQueryKey,
  StaticQueries,
  StaticQueriesMap,
  StaticQueryTable,
  StaticTableQueries,
} from "#types";
